import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/api';
import { WorkplaceRequestEventsParams } from '@gettactic/api';
import { useAuthenticated } from '@gettactic/hooks';

export function useWorkplaceRequestEvents(
  ticketId: string,
  params: WorkplaceRequestEventsParams = {}
) {
  const {
    userContext: { deviceTz, authenticatedUser }
  } = useAuthenticated();

  const queryParams = {
    ...params,
    tz: authenticatedUser?.user?.time_zone ?? deviceTz
  };

  return useInfiniteQuery({
    queryKey: ['workplaceRequestEvents', ticketId, queryParams],
    queryFn: async ({ pageParam }) => {
      const res = await api.client.workplaceRequestEvents.getWorkplaceRequestEvents(
        ticketId,
        {
          ...queryParams,
          cursor: pageParam
        }
      );
      return res.result;
    },
    getNextPageParam: (lastPage) => lastPage?.cursor ?? undefined,
    enabled: !!ticketId
  });
}
